import {
  Button,
  Modal,
  Spin,
  Typography,
  Upload,
  message,
  notification,
} from "antd";
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import {
  PlusOutlined,
  InfoOutlined,
  ExclamationCircleFilled,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { UploadDataAPI } from "../../API/UploadDataAPI";
import SuccessUpload from "../../Components/modals/SuccessUpload";
import HeaderTab from "../../Components/headerTab/HeaderTab";
import { UploadInstructions } from "../../Components/modals/UploadInstructions";
import { exportToExcelFun } from "../../Components/Utils/ExportToExl";
const { Text } = Typography;
const { Dragger } = Upload;
const { confirm } = Modal;

export default function UploadData() {
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const [notificationapi, notificationcontextHolder] =
    notification.useNotification();

  const [spinning, setSpinning] = useState(false);
  const [fileInput, setFileInput] = useState({});
  const [successUploadOpen, setSuccessIploadOpen] = useState(false);
  const [instructionsOpen, setInstructionsOpen] = useState(false);

  const props = {
    name: "file",
    multiple: false,
    customRequest: async (info) => {},
    onChange(info) {
      const { status } = info.file;
      setFileInput(info);
      if (status === "error") {
        messageToast("error", `${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      // console.log('Dropped files', e.dataTransfer.files);
    },
  };

  function postFile() {
    Object.keys(fileInput).length > 0
      ? showConfirm()
      : messageToast("warning", "Please select a File");
  }

  function editConfigFun() {
    setSuccessIploadOpen(false);
    navigate("/settings");
  }

  async function reRnakFun() {
    setSuccessIploadOpen(false);
    setSpinning(true);
    const queryParams = {
      params: {
        flight_model: localStorage.getItem("flight_model"),
      },
    };
    await UploadDataAPI.reRank(queryParams)
      .then((res) => {
        res.data.status === true
          ? navigate("/ranking")
          : messageToast("error", res.data?.message);
      })
      .catch((err) => messageToast("error", "Internal Server Error"))
      .finally(() => setSpinning(false));
  }

  const messageToast = (type, message, duration = 4) => {
    messageApi.open({
      type: type,
      content: message,
      duration: duration,
    });
  };

  const showConfirm = () => {
    confirm({
      title: "FYI !",
      icon: <ExclamationCircleFilled />,
      content: `Data will be saved under: ${localStorage.getItem("flight_model")}`,
      onOk() {
        uploadFileFun();
      },
    });
  };

  async function downloadErrorFile(data) {
    exportToExcelFun(data, "Error_Data");
  }

  async function uploadFileFun() {
    setSpinning(true);
    const formData = new FormData();
    formData.append("raw_data", fileInput?.file?.originFileObj);

    await UploadDataAPI.uploadFile(formData)
      .then((res) => {
        if (res.data.status === true) {
          messageToast("success", "File Uploaded Successfully");
          setSuccessIploadOpen(true);
          setFileInput({});
        } else {
          let message = ``;
          res.data?.message.map((ele) => {
            for (const key in ele) {
              message += `<div class='notification_div'><label>${key}</label> ${ele[key]}</div>`;
            }
          });
          const btn = (
            <div>
              <Button
                type="link"
                style={{ marginRight: "10px" }}
                onClick={() => notificationapi.destroy()}
              >
                Cancel
              </Button>
              {res.data?.er_data.length > 0 && (
                <Button
                  type="primary"
                  onClick={() => downloadErrorFile(res.data?.er_data)}
                >
                  Download Error File
                </Button>
              )}
            </div>
          );
          notificationapi.error({
            message: "Error",
            description: (
              <div dangerouslySetInnerHTML={{ __html: message }}></div>
            ),
            duration: 10,
            placement: "top",
            style: {
              width: 600,
            },
            btn,
          });
        }
      })
      .catch((err) => messageToast("error", "Internal Server Error"))
      .finally(() => setSpinning(false));
  }
  const downloadTemplate = async () => {
  try {
    const res = await UploadDataAPI.downloadTemplate();

    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "ranking_template.xlsx");
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    message.error("Failed to download template");
  }
};

  return (
    <div className="container_div">
      <Helmet>
        <title>SpecOptimzer | Upload-Data</title>
      </Helmet>

      <Spin spinning={spinning}>
        <HeaderTab currrentTab="uploadData" />

        <div className="box_wraper_div">
          <div className="table_head_wraper">
            {/* <Text className="table_head">Upload Data</Text> */}
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
      <Text className="table_head">Upload Data</Text>

      <Button
        size="small"
        type="primary"
         onClick={downloadTemplate}
      >
        Download Template
      </Button>
    </div>
            <div
              className="upload_info_div"
              onClick={() => setInstructionsOpen(true)}
            >
              <InfoOutlined
                style={{
                  backgroundColor: "#FC886B",
                  color: "#fff",
                  fontWeight: 600,
                  borderRadius: "50%",
                  padding: "2px",
                  fontSize: "12px",
                  marginRight: "10px",
                }}
              />
              important instructions
            </div>
          </div>
          <div style={{ padding: "0px 0px" }}>
            <Dragger
              progress={""}
              showUploadList={false}
              style={{ padding: "70px 0px" }}
              {...props}
            >
              <p className="ant-upload-drag-icon">
                <PlusOutlined
                  style={{
                    backgroundColor: "#EBEEF8",
                    borderRadius: "50%",
                    padding: "13px",
                    fontSize: "28px",
                  }}
                />
              </p>
              <p className="ant-upload-text">
                Drag and drop a file here to upload, or click here to browse
              </p>
              <p className="ant-upload-hint">
                {Object.keys(fileInput).length > 0 ? (
                  <Text type="success" style={{ fontWeight: 500 }}>
                    {fileInput?.file?.name}
                  </Text>
                ) : (
                  "Supported formats CSV, Excel"
                )}{" "}
              </p>
            </Dragger>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              marginTop: "40px",
              marginBottom: "20px",
            }}
          >
            <Button
              onClick={() => setFileInput({})}
              style={{ marginRight: "15px" }}
            >
              Cancel
            </Button>
            <Button onClick={postFile} type="primary">
              Upload
            </Button>
          </div>
        </div>
        <SuccessUpload
          open={successUploadOpen}
          editConfigFun={editConfigFun}
          reRnakFun={reRnakFun}
        />
        <UploadInstructions
          open={instructionsOpen}
          setOpen={setInstructionsOpen}
        />
      </Spin>
      {contextHolder}
      {notificationcontextHolder}
    </div>
  );
}
